export default "__VITE_ASSET__CauV4H$V__"